module.exports = __webpack_public_path__ + "media/images/edgevana-logo-26c37865.svg";